export { default as QuizConfigScreen } from './QuizConfigScreen';

// Future exports can be added here as the feature grows
// export { QuizConfigContext } from './QuizConfigContext';
// export { useQuizConfig } from './useQuizConfig';
// export type { QuizConfigProps } from './types';